import { getPostIdFromPath } from '@tribeplatform/react-components/common/utils'
import {
  EventDetails,
  EventDetailsLoadingSkeleton,
} from '@tribeplatform/react-components/Event'
import { useEvent } from '@tribeplatform/react-sdk/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'

type EventPageComponentType = (props: {
  spacePath: string
  eventPath: string
}) => JSX.Element

export const EventPage: EventPageComponentType = ({ eventPath }) => {
  const id = eventPath ? getPostIdFromPath(eventPath) : ''
  const { data: event, isLoading: isEventLoading } = useEvent({
    variables: { id },
    useQueryOptions: {
      enabled: !!id,
    },
  })

  return (
    <Container size="full" direction="vertical" padding="md">
      <Container size="lg" direction="vertical" spacing="lg" padding="none">
        {isEventLoading || !event ? (
          <EventDetailsLoadingSkeleton />
        ) : (
          <EventDetails event={event} />
        )}
      </Container>
    </Container>
  )
}
